import React, { Component } from "react";
import { getFailedKpiReport, getCadTopologyUuids } from "../../../../src/components/UserFunctions";
import VirtualizedSelect from "react-virtualized-select";
import { Alert } from "react-bootstrap";
import { Spin } from "antd";

class DownloadReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            downloadStatus: false,
            getCadTopologyStatus: false,
            cadTopologyErrorStatue: "",
            topologySelected: undefined,
            downloadErrorStatus: "",
            yamlDownload: false,
            loadingTip: "Yaml reports are downloading...",
        };
    }

    componentDidMount() {
        getCadTopologyUuids()
            .then((response) => {
                if (response.status === 200) {
                    this.setState({
                        cadTopologyUuid: response.data.cad_topology_options,
                        cadTopologyErrorStatue: "",
                    });
                } else {
                    console.log("getCadTopologyUuids-else", response);
                    this.setState({
                        getCadTopologyStatus: true,
                        cadTopologyErrorStatue: "Something went wrong...!",
                    });
                }
            })
            .catch((error) => {
                console.log("getCadTopologyUuids-error", error);
                this.setState({
                    getCadTopologyStatus: true,
                    cadTopologyErrorStatue: error.response.data.message,
                });
            });
    }

    onTopologyChange = (selectVal) => {
        this.setState({
            topologyOptions: selectVal,
            topologySelectValue: selectVal.value,
            topologySelected: true,
        });
    };

    downloadFailedKpireport(event) {
        event.preventDefault();
        this.setState({ topologySelected: false, yamlDownload: true });
        const payload = {
            cad_topology_job_uuid: this.state.topologySelectValue,
        };
        getFailedKpiReport(payload)
            .then((response) => {
                if (response && response.status === 200) {
                    const fileName = response.headers["content-disposition"].split("filename=")[1];
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", fileName);
                    document.body.appendChild(link);
                    link.click();
                    this.setState({ downloadErrorStatus: "", yamlDownload: false });
                } else {
                    console.log("getFailedKpiReport-else", response);
                    this.setState({
                        downloadStatus: true,
                        downloadErrorStatus: "Something went wrong...!",
                        yamlDownload: false,
                    });
                }
            })
            .catch((error) => {
                this.setState({
                    downloadStatus: true,
                    downloadErrorStatus: error.response.data.message,
                    yamlDownload: false,
                });
            });
    }

    render() {
        return (
            <div>
                <Spin spinning={this.state.yamlDownload} tip={this.state.loadingTip}>
                    <div>
                        <div
                            className="card"
                            style={{ border: "solid #757AF7", borderRadius: "0%" }}
                        >
                            <div
                                className="card-header"
                                style={{
                                    backgroundColor: "#757AF7",
                                    color: "#FFFFFF",
                                    padding: "0.5rem 0.5rem",
                                    borderRadius: "0%",
                                }}
                            >
                                YAML report for failed kpi's
                            </div>
                            <div className="row">
                                <div
                                    className="col-md-6"
                                    style={{
                                        padding: "2% 1% 0% 5%",
                                        display: "inline-block",
                                    }}
                                >
                                    Select Topology id:
                                </div>
                                <div
                                    className="col-md-6"
                                    id="example"
                                    style={{
                                        color: "#212121",
                                        display: "inline-block",
                                        padding: "1% 5% 0% 0%",
                                    }}
                                >
                                    <VirtualizedSelect
                                        options={this.state.cadTopologyUuid}
                                        onChange={(topologyOptions) =>
                                            this.onTopologyChange(topologyOptions)
                                        }
                                        value={
                                            this.state.topologySelected
                                                ? this.state.topologyOptions
                                                : null
                                        }
                                    />
                                </div>
                            </div>
                            {this.state.getCadTopologyStatus ? (
                                <Alert variant="danger">
                                    <p
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignContent: "center",
                                            fontWeight: "bold",
                                            fontSize: "20px",
                                        }}
                                    >
                                        {this.state.cadTopologyErrorStatue}
                                    </p>
                                </Alert>
                            ) : this.state.topologySelectValue ? (
                                <div>
                                    {this.state.topologySelected ? (
                                        <div
                                            className="align-items-center d-flex justify-content-center"
                                            style={{ padding: "2% 2% 2% 2%" }}
                                        >
                                            <button
                                                onClick={(e) => {
                                                    this.downloadFailedKpireport(e);
                                                }}
                                                className="btn btn-lg"
                                                style={{
                                                    backgroundColor: "#757AF7",
                                                    color: "white",
                                                }}
                                            >
                                                Download YAML Report
                                            </button>
                                        </div>
                                    ) : null}
                                    {this.state.downloadStatus ? (
                                        <Alert variant="danger">
                                            <p
                                                style={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    alignContent: "center",
                                                    fontWeight: "bold",
                                                    fontSize: "20px",
                                                }}
                                            >
                                                {this.state.downloadErrorStatus}
                                            </p>
                                        </Alert>
                                    ) : null}
                                </div>
                            ) : undefined}
                        </div>
                    </div>
                </Spin>
            </div>
        );
    }
}

export default DownloadReport;
